import { render, staticRenderFns } from "./FirmwareManage.vue?vue&type=template&id=564556e8&scoped=true"
import script from "./FirmwareManage.vue?vue&type=script&lang=js"
export * from "./FirmwareManage.vue?vue&type=script&lang=js"
import style0 from "./FirmwareManage.vue?vue&type=style&index=0&id=564556e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564556e8",
  null
  
)

export default component.exports